<script>
    export let race;
    export let canDelete = false;
    export let onDelete;

    async function handleDelete() {
        if (confirm('Are you sure you want to delete this race? This action cannot be undone.')) {
            await onDelete(race.id);
        }
    }
</script>

<style>
    .card {
        position: relative;
        min-height: 200px;
    }

    .card-content {
        padding-bottom: 3rem;
    }

    .action-buttons {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        display: flex;
        gap: 0.5rem;
    }

    .action-btn {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
        cursor: pointer;
        border: none;
        color: white;
    }

    .download-btn {
        background-color: #1976D2;
    }

    .download-btn:hover {
        background-color: #1565C0;
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .delete-btn {
        background-color: #f44336;
    }

    .delete-btn:hover {
        background-color: #d32f2f;
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .action-btn i {
        font-size: 1.2rem;
    }

    .tooltip {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 0.5rem;
        border-radius: 4px;
        font-size: 0.8rem;
        white-space: nowrap;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 1000;
    }

    .action-btn:hover .tooltip {
        opacity: 1;
    }
</style>

<div class="card">            
    <div class="card-content">
        <div class="race-title">
            <a href='results/race?raceId={race.id}'>{race.seriesName} Race {race.raceNumber}</a>
        </div>
        
        <div class="metadata">
            <p><i class="material-icons tiny">flag</i> Race type: {race.raceType}</p>
            <p><i class="material-icons tiny">schedule</i> Scheduled: {race.scheduledDt.toLocaleString('en-UK')}</p>
        </div>

        <div class="action-buttons">
       
            {#if canDelete}
                <button class="action-btn delete-btn" on:click={handleDelete} title="Remove from Cloud">
                    <i class="material-icons">delete</i>
                    <span class="tooltip">Remove from Cloud</span>
                </button>
            {/if}
        </div>
    </div>
</div>